import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'arrayToString',
  standalone: true
})
export class ArrayToStringPipe implements PipeTransform {

  transform(array: string[] | string): string {
    if (typeof array === 'string') {
      return array;
    }
    if (Array.isArray(array)) {
      return array.join(', ');
    }
    return array;
  }
}
